import { useQuery } from "@tanstack/react-query";
import { apiGetRepTop30 } from "@api/repTop30";

export function useRepTop30(repId: string | null) {
  return useQuery({
    queryKey: ["repTop30", repId],
    queryFn: () => apiGetRepTop30(repId!),
    enabled: !!repId,
    select: (res) => res.data,
  });
}
